(() => {
  const descriptionSelector = '[data-product-description]';

  function initializeDescription(description) {
    if (description.dataset.productDescriptionInitialized === 'true') return;

    const text = description.querySelector('[data-product-description-text]');
    const button = description.querySelector('[data-product-description-toggle]');
    if (!text || !button) return;

    description.dataset.productDescriptionInitialized = 'true';

    function updateCollapsedState() {
      if (description.classList.contains('is-expanded')) return;

      description.classList.add('is-collapsible');
      const hasOverflow = text.scrollHeight > text.clientHeight + 1;
      button.hidden = !hasOverflow;

      if (!hasOverflow) description.classList.remove('is-collapsible');
    }

    updateCollapsedState();
    window.addEventListener('resize', updateCollapsedState);
  }

  function initializeDescriptions(root = document) {
    if (root.matches?.(descriptionSelector)) initializeDescription(root);
    root.querySelectorAll(descriptionSelector).forEach(initializeDescription);
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-description-toggle]');
    if (!button) return;

    const description = button.closest(descriptionSelector);
    if (!description) return;

    const isExpanded = description.classList.toggle('is-expanded');
    button.textContent = isExpanded ? 'Less' : '… More';
    button.setAttribute('aria-expanded', String(isExpanded));
    button.setAttribute(
      'aria-label',
      isExpanded ? 'Afficher moins de description' : 'Afficher plus de description',
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeDescriptions());
  } else {
    initializeDescriptions();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeDescriptions(event.target);
  });
})();
